<template>
  <div class="content-area shuttle-form">
    <hero-bar>
      {{ pageTitle }}

      <b-button
        slot="right"
        icon-left="content-save"
        type="is-link"
        size="is-medium"
        :class="{'is-loading':isLoading}"
        @click="saveDetails"
      >
        {{ $t('save') }}
      </b-button>
    </hero-bar>

    <section class="section is-main-section">
      <card-component>
        <div class="columns">
          <div class="column">
            <b-field label="Güzergah Adı" horizontal>
              <b-input
                v-model="form.name"
                placeholder="Güzergah Adı"
                required
                class="is-fullwidth"
              />
            </b-field>

            <b-field label="Başlangıç Tarihi" horizontal>
              <b-datepicker
                v-model="form.startDate"
                placeholder="Seçiniz..."
                icon="calendar-today"
                :month-names="$t('dateTimePicker.monthNames')"
                :day-names="$t('dateTimePicker.dayNames')"
                trap-focus
              />
            </b-field>

            <b-field label="Konum" horizontal>
              <gmap-places
                :place.sync="form.startLocation"
                :adress="(form.startLocation.formatted_address) ? form.startLocation.formatted_address : ''"
                placeholder="Konum Seçin"
              />
            </b-field>

            <b-field label="" horizontal>
              <div v-if="form.startLocation" class="is-user-avatar has-text-centered is-center">
                <gmap-image
                  v-if="form.startLocation.latlng"
                  :latlng="form.startLocation.latlng"
                  :size="[300, 300]"
                />
              </div>
            </b-field>
          </div>

          <div class="column">
            <b-field label="Tipi" horizontal>
              <b-select
                v-model="form.type"
                placeholder="* Seçiniz *"
                expanded
              >
                <option value="enter">Giriş</option>
                <option value="exit">Çıkış</option>
              </b-select>
            </b-field>

            <b-field label="Bitiş Tarihi" horizontal>
              <b-datepicker
                v-model="form.endDate"
                :first-day-of-week="1"
                :month-names="$t('dateTimePicker.monthNames')"
                :day-names="$t('dateTimePicker.dayNames')"
                :min-date="form.startDate"
                placeholder="Seçiniz..."
                icon="calendar-today"
                trap-focus
              />
            </b-field>

            <b-field label="Ortalama Km." horizontal>
              <b-input
                v-model="form.averageKm"
                v-cleave="masks.decimal"
                placeholder="Ortalama Km."
                name="average_km"
              />
            </b-field>
          </div>

          <div class="column">
            <b-field label="Açıklama" horizontal>
              <b-input
                v-model="form.description"
                placeholder="Açıklama"
                name="description"
                required
              />
            </b-field>

            <b-field label="Saat" horizontal>
              <b-timepicker
                v-model="form.time"
                placeholder="Seçiniz..."
                icon="clock"
                :incrementMinutes="5"
              />
            </b-field>

            <b-field label="Tutar" horizontal>
              <b-input
                ref="amount"
                v-model="form.amount"
                v-cleave="masks.decimal"
                placeholder="Tutar (Km Başına)"
                name="amount"
              />
            </b-field>
          </div>
        </div>
      </card-component>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import Cleave from 'cleave.js'

export default {
  name: 'ShuttleCreateOrUpdate',
  title: ({ $i18n }) => $i18n.t('titles.newShuttlePlan'),
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
    GmapPlaces: () => import('@/components/GMapPlacesInput'),
    GmapImage: () => import('@/components/GMapImage')
  },
  directives: {
    cleave: {
      inserted: (el, binding) => {
        const input = el.querySelector('input')
        input.cleave = new Cleave(input, binding.value || {})
      },
      update: (el) => {
        const input = el.querySelector('input')
        const event = new Event('input', {bubbles: true});
        setTimeout(() => {
          input.value = input.cleave.properties.result
          input.dispatchEvent(event)
        }, 150);
      },
      unbind (el) {
        const input = el.querySelector('input')
        input.cleave.destroy()
      }
    }
   },
  data () {
    return {
      isLoading: false,
      pageTitle: null,
      form: {
        name: '',
        description: '',
        startLocation: {},
        type: null,
        startDate: null,
        endDate: null,
        time: null,
        averageKm: null,
        amount: null,
      },
      masks: {
        decimal: {
          numeral: true,
          numeralDecimalMark: ',',
          numeralThousandsGroupStyle: 'thousand',
          delimiter: '.'
        }
      }
    }
  },
  computed: {
    isCreate () {
      return this.$route.name == 'shuttle_create'
    },
    id () {
      return this.$route.params.id;
    }
  },
  beforeDestroy () {
    this.$store.commit('setAsideActiveMenuKey', '')
  },
  mounted () {
    this.$store.commit('setAsideActiveMenuKey', 'shuttle_list')

    if (this.isCreate) {
      this.pageTitle = this.$t('shuttlePlanCreate')
    } else {
      this.pageTitle = this.$t('shuttlePlanEdit')

      this.$nextTick(() => {
        this.getPlan();
      });
    }

    document.title = this.pageTitle
  },
  methods: {
    saveDetails () {
      let startAddress = this.form.startLocation.formatted_address;
      const startDate = moment(this.form.startDate).format('YYYY-MM-DD').toString();
      const endDate = moment(this.form.endDate).format('YYYY-MM-DD').toString();
      const time = moment(this.form.time).format('HH:mm').toString();

      if (!this.$_.isUndefined(this.form.startLocation.name)) {
        startAddress = `${this.form.startLocation.name} - ${startAddress}`;
      }

      const params = {
        name: this.form.name,
        description: this.form.description,
        start_address: startAddress,
        start_location: this.form.startLocation.latlng,
        start_date: startDate,
        end_date: endDate,
        time: time,
        type: this.form.type,
        average_km: this.form.averageKm,
        amount: this.form.amount,
      };

      let postUrl;

      if (this.isCreate) {
        postUrl = 'shuttle-create'
      } else {
        postUrl = 'shuttle-edit'
        params.id = this.id
      }

      this.isLoading = true;
      this.$http
        .post(postUrl, params)
        .then(r => {
          if (r.data.success) {
            this.$buefy.toast.open({
              message: this.$t('shuttlePlanCreated'),
              type: 'is-success',
              duration: 5000
            });

            this.$router.push({ name: 'shuttle_list' });
          }
        })
        .catch(e => {
          const errors = this.parseError(e);
          this.$buefy.toast.open({
            message: this.$t('error') + ': <br>' + errors,
            type: 'is-warning',
            duration: 5000
          });
        })
        .then(() => {
          this.isLoading = false;
        })
    },
    getPlan () {
      this.showSpinner()
      this.$http.get(`shuttle/${this.id}`)
        .then(({ data }) => {
          this.form.name = data.name
          this.form.description = data.description
          this.form.time = moment(`2020-05-05 ${data.time}`).toDate()
          this.form.type = data.type
          this.form.startDate = moment(data.start_date).toDate()
          this.form.endDate = moment(data.end_date).toDate()

          document.querySelector('input[name=\'amount\']').cleave.setRawValue(data.amount);
          document.querySelector('input[name=\'average_km\']').cleave.setRawValue(data.average_km);

          this.form.startLocation.formatted_address = data.start_address
          this.form.startLocation.latlng = data.start_location
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: this.$t('error'),
            type: 'is-warning',
            duration: 5000
          });
          this.$router.push({ name:'shuttle_list' });
        })
        .finally(() => {
          this.hideSpinner()
        });
    }
  }
}
</script>
